module.exports = __webpack_public_path__ + "img/asanmobile5.6bc2dfe3.jpeg";